export default {"src":"/_next/static/image/src/images/our-food/butternut-squash.d2abfb6a5348d48d5dded769931292ac.svg","height":38,"width":72};